/**
 * Sign-in, session and own account security shared by every app (ADR-015 §10,
 * docs/authentication.md). E1: sign in, second factor, status screens, re-authentication and the
 * minimal security panel. E2: activation of an invitation (`/acceso/activar`). E3: password
 * recovery (`/acceso/recuperar`), Google (`/acceso/google`, sign-in, link, re-authentication), own
 * password change and the voluntary second factor with the WhatsApp code.
 */
import { captureActivationToken } from './activation-token';
import { captureGoogleReturn } from './google-return';

export { AuthCard, AuthenticatorSetup, authMessage, CodeInput, countdown, errorCode, NewPassword, QrCode, RecoveryCodes, retryAfterSeconds, waitText, type AuthBrand } from './pieces';
export { Activation, type ActivationProps } from './Activation';
export { ACTIVATION_PATH, captureActivationToken, clearActivationToken } from './activation-token';
export { captureGoogleReturn, GOOGLE_PATH, goToGoogle, saveReturnPath } from './google-return';
export { GoogleLanding, GOOGLE_FAILED } from './GoogleLanding';
export { REAUTH_CANCELLED, ReauthProvider, useReauth } from './Reauth';
export { Recovery, RECOVERY_PATHS, RECOVERY_SENT, type RecoveryStep } from './Recovery';
export { ChallengeStep, type Challenge } from './ChallengeStep';
export { SignIn, type SignInProps } from './SignIn';
export { isStatusMotive, MOTIVE_OF_CODE, MOTIVE_OF_REASON, NoPermission, STATUS_MOTIVES, StatusCard, StatusScreen, type StatusMotive } from './StatusScreen';
export { ChangePasswordDialog, deviceName, EnrollDialog, SECURITY_NOTICE_LABEL, SecurityPanel, securityNoticeLabel, type OwnSession } from './SecurityPanel';
export { ACCESS_PREFIX, SessionGate, useSessionState, type GateRouter, type SessionGateProps, type SessionMe } from './SessionGate';

/**
 * Takes every secret the address may carry in its fragment (invitation token, Google's tickets)
 * out of the address bar and keeps it in memory. Each app calls it first thing, before rendering.
 */
export function captureAuthFragments(): void {
  captureActivationToken();
  captureGoogleReturn();
}
